import React, { useEffect } from "react";
import Breadcrumb from "../components/Breadcrumb";
import ShopSection from "../components/ShopSection";
import { useProductStore } from "../store/useProductStore";
import { useCategoryStore } from "../store/useCategoryStore";

const Shop = () => {
  const { getAllProduct } = useProductStore()
  const { setSelectedCategory } = useCategoryStore()

  useEffect(() => {
    const fetchData = async () => {
      setSelectedCategory(null, "All")
      // await getAllProduct(1, 10, '', '');
    };
    fetchData();
  }, []);
  return (
    <>
      <Breadcrumb title="Shop" />
      <ShopSection />
    </>
  );
};

export default Shop;